export const MultiChoiceSVG = (iconColor = "#B9B9B9") => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5Z"
                fill={iconColor}
            />
        </svg>
    );
};
export const MultiChoiceSelectedSVG = (iconColor = "#9035FF") => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
                fill={iconColor}
            />
        </svg>
    );
};
export const SingleChoiceSVG = (iconColor = "#B9B9B9") => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                fill={iconColor}
            />
        </svg>
    );
};
export const SingleChoiceSelectedSVG = (iconColor = "#9035FF") => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17Z"
                fill={iconColor}
            />
        </svg>
    );
};
export const CancelButton = (iconColor = "#B9B9B9") => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19.5469 6.42188L13.9219 12.0469L19.5 17.625C19.9688 18.0469 19.9688 18.75 19.5 19.1719C19.0781 19.6406 18.375 19.6406 17.9531 19.1719L12.3281 13.5938L6.75 19.1719C6.32812 19.6406 5.625 19.6406 5.20312 19.1719C4.73438 18.75 4.73438 18.0469 5.20312 17.5781L10.7812 12L5.20312 6.42188C4.73438 6 4.73438 5.29688 5.20312 4.82812C5.625 4.40625 6.32812 4.40625 6.79688 4.82812L12.375 10.4531L17.9531 4.875C18.375 4.40625 19.0781 4.40625 19.5469 4.875C19.9688 5.29688 19.9688 6 19.5469 6.42188Z" fill={iconColor} />
        </svg>
    );
};
export const CloseIcon = (iconColor = '#B9B9B9') => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M19.5469 6.42188L13.9219 12.0469L19.5 17.625C19.9688 18.0469 19.9688 18.75 19.5 19.1719C19.0781 19.6406 18.375 19.6406 17.9531 19.1719L12.3281 13.5938L6.75 19.1719C6.32812 19.6406 5.625 19.6406 5.20312 19.1719C4.73438 18.75 4.73438 18.0469 5.20312 17.5781L10.7812 12L5.20312 6.42188C4.73438 6 4.73438 5.29688 5.20312 4.82812C5.625 4.40625 6.32812 4.40625 6.79688 4.82812L12.375 10.4531L17.9531 4.875C18.375 4.40625 19.0781 4.40625 19.5469 4.875C19.9688 5.29688 19.9688 6 19.5469 6.42188Z" fill={iconColor} />
    </svg>
}
export const CorrectIcon = (iconColor = '#0DC268') => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8.01562 16C5.14062 16 2.51562 14.5 1.07812 12C-0.359375 9.53125 -0.359375 6.5 1.07812 4C2.51562 1.53125 5.14062 0 8.01562 0C10.8594 0 13.4844 1.53125 14.9219 4C16.3594 6.5 16.3594 9.53125 14.9219 12C13.4844 14.5 10.8594 16 8.01562 16ZM11.5469 6.53125H11.5156C11.8281 6.25 11.8281 5.78125 11.5156 5.46875C11.2344 5.1875 10.7656 5.1875 10.4844 5.46875L7.01562 8.96875L5.54688 7.5C5.23438 7.1875 4.76562 7.1875 4.48438 7.5C4.17188 7.78125 4.17188 8.25 4.48438 8.53125L6.48438 10.5312C6.76562 10.8438 7.23438 10.8438 7.54688 10.5312L11.5469 6.53125Z" fill={iconColor} />
    </svg>
}
export const WrongIcon = (iconColor = '#ED0A34') => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8.01562 16C5.14062 16 2.51562 14.5 1.07812 12C-0.359375 9.53125 -0.359375 6.5 1.07812 4C2.51562 1.53125 5.14062 0 8.01562 0C10.8594 0 13.4844 1.53125 14.9219 4C16.3594 6.5 16.3594 9.53125 14.9219 12C13.4844 14.5 10.8594 16 8.01562 16ZM5.48438 5.46875C5.17188 5.78125 5.17188 6.25 5.48438 6.53125L6.95312 8L5.48438 9.46875C5.17188 9.78125 5.17188 10.25 5.48438 10.5312C5.76562 10.8438 6.23438 10.8438 6.51562 10.5312L7.98438 9.0625L9.45312 10.5312C9.76562 10.8438 10.2344 10.8438 10.5156 10.5312C10.8281 10.25 10.8281 9.78125 10.5156 9.46875L9.04688 8L10.5156 6.53125C10.8281 6.25 10.8281 5.78125 10.5156 5.46875C10.2344 5.1875 9.76562 5.1875 9.45312 5.46875L7.98438 6.9375L6.51562 5.46875C6.23438 5.1875 5.76562 5.1875 5.48438 5.46875Z" fill={iconColor} />
    </svg>
}
export const BackIcon = (iconColor = '#090C0F') => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
        <path d="M0.25 7.48678C0.0714286 7.30821 0 7.09393 0 6.84393C0 6.62964 0.0714286 6.41536 0.25 6.23678L6.53571 0.236783C6.89286 -0.0846451 7.42857 -0.0846451 7.75 0.272498C8.07143 0.593926 8.07143 1.16535 7.71429 1.48678L2.96429 5.98678H15.1429C15.6071 5.98678 16 6.37964 16 6.84393C16 7.34393 15.6071 7.70107 15.1429 7.70107H2.96429L7.71429 12.2368C8.07143 12.5582 8.07143 13.0939 7.75 13.4511C7.42857 13.8082 6.89286 13.8082 6.53571 13.4868L0.25 7.48678Z" fill={iconColor} />
    </svg>
}